import { uiText, useUiLanguage } from '../../utils/uiTranslation';
import React from 'react';
import { ref, set } from 'firebase/database';
import { database } from '../../firebase';
import { useAuth } from '../../contexts/AuthContext';

const FilteringSubstagePopup = ({ onClose, onAddFilteringLayer }) => {
  useUiLanguage();
  const { currentUser } = useAuth();

  const handleAddFiltering = async () => {
    if (!currentUser) {
      alert(uiText('You must be logged in to perform this action.'));
      return;
    }
    try {
      // Use the function passed from parent component
      await onAddFilteringLayer();
      // The parent component will handle closing the popup and updating state
    } catch (error) {
      console.error('Error adding filtering layer:', error);
      alert(uiText('Error adding filtering feature. Please try again.'));
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{uiText("Applicant Filtering")}</h2>
          <div className="close" onClick={onClose}>&times;</div>
        </div>
        
        <div className="modal-page-container">
          <div className="form-section">
            <div className="substage-popup-header" style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              marginBottom: '15px'
            }}>
              <i className="fa-solid fa-filter" style={{color: '#568ded'}}></i>
              <p style={{
                fontFamily: 'Montserrat, sans-serif',
                color: "var(--app-neutral-ink, #000000)",
                fontSize: '24px',
                marginRight: '2px',
                marginLeft: '10px',
                marginBottom: '0'
              }}>{uiText("Filtering Configuration")}</p>
            </div>
            
            <p style={{ margin: '15px 0' }}>
              <strong>{uiText("About:")}</strong>{uiText(" This feature seamlessly filters applicants for a specific job by comparing their resumes with the job description. It ensures that only the most relevant candidates are selected for further review.")}</p>
          </div>
        </div>

        <div className="modal-footer">
          <button 
            onClick={handleAddFiltering}
            className="btn-primary"
          >{uiText("Add Filtering")}</button>
        </div>
      </div>
    </div>
  );
};

export default FilteringSubstagePopup; 